import React from "react";
import RoutingLayout from "./routing";
import BackofficeLayout from "./backoffice";

export enum LayoutType {
  ROUTING = "routing",
  BACKOFFICE = "backoffice",
}

const AppLayout = ({ layoutType = LayoutType.ROUTING }: { layoutType?: LayoutType }) => {
  if (layoutType === LayoutType.BACKOFFICE) {
    return <BackofficeLayout />;
  }
  
  return <RoutingLayout />;
};

export default AppLayout;
